import React from 'react';
import note from '../content/reportSecurityNote.json';

export const ReportSecurityNote = ({ dark = false, className = '' }) => (
  <section
    data-testid="report-cybersecurity-note"
    aria-label={note.title}
    className={`mt-8 border-t pt-5 pb-3 text-left break-words print:break-inside-avoid print:text-gray-800 ${dark ? 'border-white/20 text-white/80' : 'border-gray-200 text-gray-700'} ${className}`}
  >
    <h2 data-testid="report-cybersecurity-title" className={`text-base md:text-lg font-semibold mb-3 ${dark ? 'text-white print:text-gray-900' : 'text-gray-900'}`}>
      {note.title}
    </h2>
    <ul className="list-disc pl-5 space-y-2 text-sm leading-relaxed">
      {note.measures.map((text, index) => <li key={text} data-testid={`report-cybersecurity-measure-${index}`}>{text}</li>)}
    </ul>
    <p data-testid="report-cybersecurity-platform" className="text-sm leading-relaxed mt-3">
      <span className="font-semibold">{note.platform_attribution}</span>{' '}{note.platform_statement}
    </p>
    <p data-testid="report-cybersecurity-sharing" className="text-sm leading-relaxed mt-3">{note.advice}</p>
    <p data-testid="report-cybersecurity-disclaimer" className="text-xs leading-relaxed mt-2">{note.disclaimer}</p>
  </section>
);